const themeTableNormal = () => import('@/views/main/dataList/themeTableNormal.vue')
export default {
  path: '/main/dataList/themeTableNormal/:id',
  name: 'themeTableNormal',
  component: themeTableNormal,
  children: []
}
